import { useIsSub } from 'affiny-core/hooks';
import { selectIsMainLayoutVisible } from 'affiny-core/redux/selectors/visibilityUiSelectors';
import { Footer } from 'affiny-desktop/src/components/desktop/footer/Footer';
import {
  Header,
  HEADER_HEIGHT,
} from 'affiny-desktop/src/components/desktop/header/Header';
import { HEADER_ZINDEX } from 'affiny-desktop/src/constants';
import { Box, Flex } from 'affiny-ui/src';
import { AnimatePresence, motion } from 'framer-motion';
import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  MainLayoutRegHeadband,
  REGHEADBAND_HEIGHT,
} from './MainLayoutRegHeadband';

interface IMainLayout {
  children: ReactNode;
}

const DURATION_ANIMATION = 0.7;

export const MainLayout = ({ children }: IMainLayout) => {
  const isSub = useIsSub();
  const isMainLayoutVisible = useSelector(selectIsMainLayoutVisible);

  return (
    <AnimatePresence initial={false}>
      <TranslationProvider
        initial={{
          opacity: 1,
          height: '100%',
          overflow: 'inherit',
        }}
        animate={{
          transition: { duration: DURATION_ANIMATION },
          opacity: isMainLayoutVisible ? 1 : 0,
          height: isMainLayoutVisible ? '100%' : '0px',
          overflow: isMainLayoutVisible ? 'inherit' : 'hidden',
        }}
      >
        <Flex
          flexDirection="column"
          minHeight="100vh"
          pt={
            isSub
              ? HEADER_HEIGHT
              : `calc(${HEADER_HEIGHT} + ${REGHEADBAND_HEIGHT})`
          }
        >
          <Box
            position="fixed"
            top={0}
            left={0}
            right={0}
            zIndex={HEADER_ZINDEX}
          >
            {!isSub && <MainLayoutRegHeadband />}
            <Header />
          </Box>

          <Flex minHeight="100%">{children}</Flex>

          <Footer />
        </Flex>
      </TranslationProvider>
    </AnimatePresence>
  );
};

const TranslationProvider = styled(motion.div)`
  display: flex;
  height: 100%;
  width: 100%;
`;
